export const userInitials = (user) => {
  if (!user) { return ''; }
  return user.login.substring(0, 2).toUpperCase();
};
